/*----------------------------------------后台Api地址----------------------------------------*/
//export const APP_HOST_URL = 'http://hzx.sxhys.com/';
// export const APP_HOST_URL = 'http://cangyun.changtu.com/';
// export const APP_HOST_URL = 'http://localhost:57531/';
// export const APP_HOST_URL = 'http://172.19.3.81:8178/';
// export const APP_SERVE_URL = APP_HOST_URL+'api/services/app/open/';
// export const LOGIN_URL = APP_HOST_URL+'api/account/authenticate';
// export const LOGIN_URL_TOUCH = APP_HOST_URL+'account/login';
// export const LOGINOUT_URL_TOUCH = APP_HOST_URL+ 'account/Logout';
// export const SET_COOKIES = APP_HOST_URL+ 'api/AntiForgery/SetTokenCookie';
 

export const LoadingImage = "assets/img/loading.gif";

export const IS_APP = INDEX_IS_APP;

export const APP_SUBURL = "/v2";

export const IS_DEBUG = false;//是否开发(调试)模式

export const REQUEST_TIMEOUT = 60000;//请求超时时间,单位为毫秒
export const ENABLE_FUNDEBUG = true;//是否启用fundebug日志监控

export const CcbPayModel = "00";
export const WxAppSchema = "ronglian1000102337mobilepay";
export const WxAppid = "wx9b4839c6e3ffbe1e";






// WEBPACK FOOTER //
// ./src/providers/Constants.ts